export const fieldsMessage = {
  required: (field) => `${field} is required.`,
  invalidFormat: (field) => `${field} has an invalid format.`,
  maxLength: (field, min) => `${field} must have a maximum of ${min} characters.`,
  typeFile: (field, formats) => {
  const text =
    formats.length > 1
      ? `${formats.slice(0, -1).join(", ")} or ${formats.at(-1)}`
      : formats[0];

  return `The field ${field} has an invalid file type. File must be ${text}.`;
},
  sizeFile: (field, size) => `${field} has exceed the size limit. File must have a maximum of ${size}MB`,
};